// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Float from "@rescript/core/src/Core__Float.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "../Utilities/LoggerUtils.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as NetworkInformation$OrcaPaymentPage from "../Hooks/NetworkInformation.bs.js";

function logFileToObj(logFile) {
  let match = logFile.logType;
  let tmp;
  switch (match) {
    case "DEBUG" :
      tmp = "DEBUG";
      break;
    case "INFO" :
      tmp = "INFO";
      break;
    case "ERROR" :
      tmp = "ERROR";
      break;
    case "WARNING" :
      tmp = "WARNING";
      break;
    case "SILENT" :
      tmp = "SILENT";
      break;
  }
  let match$1 = logFile.category;
  let tmp$1;
  switch (match$1) {
    case "API" :
      tmp$1 = "API";
      break;
    case "USER_ERROR" :
      tmp$1 = "USER_ERROR";
      break;
    case "USER_EVENT" :
      tmp$1 = "USER_EVENT";
      break;
    case "MERCHANT_EVENT" :
      tmp$1 = "MERCHANT_EVENT";
      break;
  }
  return Object.fromEntries([
    [
      "timestamp",
      logFile.timestamp
    ],
    [
      "log_type",
      tmp
    ],
    [
      "component",
      "WEB"
    ],
    [
      "category",
      tmp$1
    ],
    [
      "source",
      LoggerUtils$OrcaPaymentPage.convertToScreamingSnakeCase(logFile.source)
    ],
    [
      "version",
      logFile.version
    ],
    [
      "value",
      logFile.value
    ],
    [
      "session_id",
      logFile.sessionId
    ],
    [
      "merchant_id",
      logFile.merchantId
    ],
    [
      "payment_id",
      logFile.paymentId
    ],
    [
      "app_id",
      logFile.appId
    ],
    [
      "platform",
      LoggerUtils$OrcaPaymentPage.convertToScreamingSnakeCase(logFile.platform)
    ],
    [
      "user_agent",
      logFile.userAgent
    ],
    [
      "event_name",
      LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(logFile.eventName)
    ],
    [
      "browser_name",
      LoggerUtils$OrcaPaymentPage.convertToScreamingSnakeCase(logFile.browserName)
    ],
    [
      "browser_version",
      logFile.browserVersion
    ],
    [
      "latency",
      logFile.latency
    ],
    [
      "first_event",
      Utils$OrcaPaymentPage.getStringFromBool(logFile.firstEvent)
    ],
    [
      "payment_method",
      LoggerUtils$OrcaPaymentPage.convertToScreamingSnakeCase(logFile.paymentMethod)
    ]
  ]);
}

function getRefFromOption(val) {
  let innerValue = Core__Option.getOr(val, "");
  return {
    contents: innerValue
  };
}

function getSourceString(source) {
  if (typeof source !== "object") {
    if (source === "Loader") {
      return "hyper_loader";
    } else {
      return "headless";
    }
  }
  let formattedPaymentMode = LoggerUtils$OrcaPaymentPage.toSnakeCaseWithSeparator(CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(source._0), "_");
  return "hyper" + formattedPaymentMode;
}

function make(sessionId, source, clientSecret, merchantId, metadata) {
  let match = loggingLevel;
  let loggingLevel$1;
  switch (match) {
    case "DEBUG" :
      loggingLevel$1 = "DEBUG";
      break;
    case "ERROR" :
      loggingLevel$1 = "ERROR";
      break;
    case "INFO" :
      loggingLevel$1 = "INFO";
      break;
    case "WARNING" :
      loggingLevel$1 = "WARNING";
      break;
    default:
      loggingLevel$1 = "SILENT";
  }
  let mainLogFile = [];
  let sessionId$1 = getRefFromOption(sessionId);
  let setSessionId = value => {
    sessionId$1.contents = value;
  };
  let sourceString = getSourceString(source);
  let events = {
    contents: {}
  };
  let eventsCounter = {
    contents: {}
  };
  let timeOut = {
    contents: undefined
  };
  let merchantId$1 = getRefFromOption(merchantId);
  let setMerchantId = value => {
    merchantId$1.contents = value;
  };
  let metadata$1 = {
    contents: Core__Option.getOr(metadata, null)
  };
  let setMetadata = value => {
    metadata$1.contents = value;
  };
  let calculateAndUpdateCounterHook = eventName => {
    let num = eventsCounter.contents[eventName];
    let updatedCounter = num !== undefined ? num + 1 | 0 : 1;
    eventsCounter.contents[eventName] = updatedCounter;
    return updatedCounter;
  };
  let conditionalLogPush = log => {
    let maxLogsPushedPerEventName = globalThis.maxLogsPushedPerEventName;
    let match = log.eventName;
    let conditionalEventName;
    conditionalEventName = match === "INPUT_FIELD_CHANGED" ? log.value : "";
    let eventName = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(log.eventName) + conditionalEventName;
    let counter = calculateAndUpdateCounterHook(eventName);
    if (!(enableLogging && counter <= maxLogsPushedPerEventName)) {
      return;
    }
    switch (loggingLevel$1) {
      case "DEBUG" :
        mainLogFile.push(log);
        return;
      case "INFO" :
        if ([
            "INFO",
            "WARNING",
            "ERROR"
          ].includes(log.logType)) {
          mainLogFile.push(log);
          return;
        } else {
          return;
        }
      case "ERROR" :
        if (["ERROR"].includes(log.logType)) {
          mainLogFile.push(log);
          return;
        } else {
          return;
        }
      case "WARNING" :
        if ([
            "WARNING",
            "ERROR"
          ].includes(log.logType)) {
          mainLogFile.push(log);
          return;
        } else {
          return;
        }
      case "SILENT" :
        return;
    }
  };
  let beaconApiCall = data => {
    if (data.length <= 0) {
      return;
    }
    let logData = JSON.stringify(data.map(logFileToObj));
    navigator.sendBeacon(logEndpoint, logData);
  };
  let sendCachedLogsFromIDB = async () => {
    try {
      let logs = await LoggerUtils$OrcaPaymentPage.retrieveLogsFromIndexedDB();
      if (logs.length > 0) {
        beaconApiCall(logs);
        return await LoggerUtils$OrcaPaymentPage.clearLogsFromIndexedDB();
      } else {
        return;
      }
    } catch (exn) {
      return;
    }
  };
  let clientSecret$1 = getRefFromOption(clientSecret);
  let setClientSecret = value => {
    clientSecret$1.contents = value;
  };
  let sdkAuthorization = {
    contents: undefined
  };
  let setSdkAuthorization = value => {
    sdkAuthorization.contents = value === "" ? undefined : value;
  };
  let getPaymentId = () => Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret$1.contents, sdkAuthorization.contents);
  let sourceRef = {
    contents: getSourceString(source)
  };
  let setSource = value => {
    sourceRef.contents = value;
  };
  let clearLogFile = mainLogFile => {
    let len = mainLogFile.length;
    for (let _for = 0; _for < len; ++_for) {
      mainLogFile.pop();
    }
  };
  let sendLogsToIndexedDB = async () => {
    try {
      await LoggerUtils$OrcaPaymentPage.saveLogsToIndexedDB(mainLogFile);
      return clearLogFile(mainLogFile);
    } catch (exn) {
      return;
    }
  };
  let sendLogsOverNetwork = async () => {
    try {
      await sendCachedLogsFromIDB();
      beaconApiCall(mainLogFile);
      return clearLogFile(mainLogFile);
    } catch (exn) {
      return;
    }
  };
  let sendLogs = () => {
    let val = timeOut.contents;
    if (val !== undefined) {
      clearTimeout(Primitive_option.valFromOption(val));
      timeOut.contents = Primitive_option.some(setTimeout(() => sendLogs(), 20000));
    } else {
      timeOut.contents = Primitive_option.some(setTimeout(() => sendLogs(), 20000));
    }
    let val$1 = NetworkInformation$OrcaPaymentPage.getNetworkState();
    let networkStatus;
    networkStatus = typeof val$1 !== "object" ? NetworkInformation$OrcaPaymentPage.defaultNetworkState : val$1._0;
    if (networkStatus.isOnline) {
      sendLogsOverNetwork();
    } else {
      sendLogsToIndexedDB();
    }
  };
  let checkForPriorityEvents = arrayOfLogs => {
    let priorityEventNames = [
      "APP_RENDERED",
      "ORCA_ELEMENTS_CALLED",
      "PAYMENT_DATA_FILLED",
      "PAYMENT_ATTEMPT",
      "CONFIRM_CALL",
      "AUTHENTICATION_CALL",
      "THREE_DS_METHOD_RESULT",
      "SDK_CRASH",
      "REDIRECTING_USER",
      "DISPLAY_BANK_TRANSFER_INFO_PAGE",
      "DISPLAY_QR_CODE_INFO_PAGE",
      "DISPLAY_VOUCHER",
      "LOADER_CHANGED",
      "PAYMENT_METHOD_CHANGED",
      "SESSIONS_CALL",
      "CLIENT_LIST_CALL",
      "RETRIEVE_CALL",
      "DISPLAY_THREE_DS_SDK",
      "APPLE_PAY_FLOW",
      "PLAID_SDK",
      "NETWORK_STATE",
      "DDC_FLOW",
      "GOOGLE_PAY_SCRIPT",
      "GOOGLE_PAY_FLOW"
    ];
    if (Core__Option.isSome(arrayOfLogs.find(log => [
        "ERROR",
        "DEBUG"
      ].includes(log.logType) ? true : (
          priorityEventNames.includes(log.eventName) ? log.firstEvent : false
        )))) {
      return true;
    } else {
      return arrayOfLogs.length > 8;
    }
  };
  let checkLogSizeAndSendData = () => {
    let val = timeOut.contents;
    if (val !== undefined) {
      clearTimeout(Primitive_option.valFromOption(val));
      timeOut.contents = Primitive_option.some(setTimeout(() => sendLogs(), 20000));
    } else {
      timeOut.contents = Primitive_option.some(setTimeout(() => sendLogs(), 20000));
    }
    if (checkForPriorityEvents(mainLogFile)) {
      return sendLogs();
    }
  };
  let calculateLatencyHook = (eventName, apiLogTypeOpt) => {
    let apiLogType = apiLogTypeOpt !== undefined ? apiLogTypeOpt : "Method";
    let currentTimestamp = Date.now();
    let latency;
    if (eventName === "PAYMENT_ATTEMPT") {
      let appRenderedTimestamp = events.contents[LoggerUtils$OrcaPaymentPage.eventNameToStrMapper("APP_RENDERED")];
      latency = appRenderedTimestamp !== undefined ? currentTimestamp - appRenderedTimestamp : 0;
    } else {
      let logRequestTimestamp = events.contents[LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(eventName) + "_INIT"];
      latency = logRequestTimestamp !== undefined ? (
          apiLogType === "Request" ? 0 : currentTimestamp - logRequestTimestamp
        ) : 0;
    }
    if (latency > 0) {
      return latency.toString();
    } else {
      return "";
    }
  };
  let checkAndPushMissedEvents = (eventName, paymentMethod) => {
    if (eventName !== "PAYMENT_ATTEMPT") {
      return;
    }
    let paymentMethodChangedEventStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper("PAYMENT_METHOD_CHANGED");
    let paymentDataFilledEventStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper("PAYMENT_DATA_FILLED");
    let localTimestamp = Date.now().toString();
    let localTimestampFloat = Core__Option.getOr(Core__Float.fromString(localTimestamp), Date.now());
    let paymentMethodChangedEvent = Core__Option.isNone(events.contents[paymentMethodChangedEventStr]);
    let paymentDataFilledEvent = Core__Option.isNone(events.contents[paymentDataFilledEventStr]);
    if (paymentMethodChangedEvent) {
      conditionalLogPush({
        timestamp: localTimestamp,
        logType: "INFO",
        category: "USER_EVENT",
        source: sourceString,
        version: repoVersion,
        value: "",
        sessionId: sessionId$1.contents,
        merchantId: merchantId$1.contents,
        paymentId: getPaymentId(),
        appId: "",
        platform: window.navigator.platform,
        browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
        browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
        userAgent: window.navigator.userAgent,
        eventName: "PAYMENT_METHOD_CHANGED",
        latency: "",
        firstEvent: true,
        paymentMethod: paymentMethod,
        metadata: metadata$1.contents
      });
      events.contents[paymentMethodChangedEventStr] = localTimestampFloat;
    }
    if (paymentDataFilledEvent) {
      conditionalLogPush({
        timestamp: localTimestamp,
        logType: "INFO",
        category: "USER_EVENT",
        source: sourceString,
        version: repoVersion,
        value: "",
        sessionId: sessionId$1.contents,
        merchantId: merchantId$1.contents,
        paymentId: getPaymentId(),
        appId: "",
        platform: window.navigator.platform,
        browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
        browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
        userAgent: window.navigator.userAgent,
        eventName: "PAYMENT_DATA_FILLED",
        latency: "",
        firstEvent: true,
        paymentMethod: paymentMethod,
        metadata: metadata$1.contents
      });
      events.contents[paymentDataFilledEventStr] = localTimestampFloat;
      return;
    }
  };
  let setLogInfo = (value, eventName, timestamp, latency, logTypeOpt, logCategoryOpt, paymentMethodOpt) => {
    let logType = logTypeOpt !== undefined ? logTypeOpt : "INFO";
    let logCategory = logCategoryOpt !== undefined ? logCategoryOpt : "USER_EVENT";
    let paymentMethod = paymentMethodOpt !== undefined ? paymentMethodOpt : "";
    checkAndPushMissedEvents(eventName, paymentMethod);
    let eventNameStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(eventName);
    let firstEvent = Core__Option.isNone(events.contents[eventNameStr]);
    let latency$1 = latency !== undefined ? latency.toString() : calculateLatencyHook(eventName, undefined);
    let localTimestamp = Core__Option.getOr(timestamp, Date.now().toString());
    let localTimestampFloat = Core__Option.getOr(Core__Float.fromString(localTimestamp), Date.now());
    conditionalLogPush({
      timestamp: localTimestamp,
      logType: logType,
      category: logCategory,
      source: sourceString,
      version: repoVersion,
      value: value,
      sessionId: sessionId$1.contents,
      merchantId: merchantId$1.contents,
      paymentId: getPaymentId(),
      appId: "",
      platform: window.navigator.platform,
      browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
      browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
      userAgent: window.navigator.userAgent,
      eventName: eventName,
      latency: latency$1,
      firstEvent: firstEvent,
      paymentMethod: paymentMethod,
      metadata: metadata$1.contents
    });
    checkLogSizeAndSendData();
    events.contents[eventNameStr] = localTimestampFloat;
  };
  let setConfirmPaymentValue = paymentType => Object.fromEntries([
    [
      "method",
      "confirmPayment"
    ],
    [
      "type",
      paymentType
    ]
  ]);
  let setLogApi = (value, eventName, timestamp, logTypeOpt, logCategoryOpt, paymentMethodOpt, apiLogTypeOpt, isPaymentSessionOpt) => {
    let logType = logTypeOpt !== undefined ? logTypeOpt : "INFO";
    let logCategory = logCategoryOpt !== undefined ? logCategoryOpt : "API";
    let paymentMethod = paymentMethodOpt !== undefined ? paymentMethodOpt : "";
    let apiLogType = apiLogTypeOpt !== undefined ? apiLogTypeOpt : "Request";
    let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
    let eventNameStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(eventName);
    let firstEvent = Core__Option.isNone(events.contents[eventNameStr]);
    let latency = calculateLatencyHook(eventName, apiLogType);
    let localTimestamp = Core__Option.getOr(timestamp, Date.now().toString());
    let localTimestampFloat = Core__Option.getOr(Core__Float.fromString(localTimestamp), Date.now());
    let tmp;
    tmp = value.TAG === "ArrayType" ? JSON.stringify(Object.fromEntries(value._0)) : value._0;
    conditionalLogPush({
      timestamp: localTimestamp,
      logType: logType,
      category: logCategory,
      source: isPaymentSession ? "headless" : sourceString,
      version: repoVersion,
      value: tmp,
      sessionId: sessionId$1.contents,
      merchantId: merchantId$1.contents,
      paymentId: getPaymentId(),
      appId: "",
      platform: window.navigator.platform,
      browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
      browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
      userAgent: window.navigator.userAgent,
      eventName: eventName,
      latency: latency,
      firstEvent: firstEvent,
      paymentMethod: paymentMethod,
      metadata: metadata$1.contents
    });
    checkLogSizeAndSendData();
    events.contents[eventNameStr] = localTimestampFloat;
  };
  let setLogError = (value, eventName, timestamp, latency, logTypeOpt, logCategoryOpt, paymentMethodOpt) => {
    let logType = logTypeOpt !== undefined ? logTypeOpt : "ERROR";
    let logCategory = logCategoryOpt !== undefined ? logCategoryOpt : "USER_ERROR";
    let paymentMethod = paymentMethodOpt !== undefined ? paymentMethodOpt : "";
    let eventNameStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper(eventName);
    let firstEvent = Core__Option.isNone(events.contents[eventNameStr]);
    let latency$1 = latency !== undefined ? latency.toString() : calculateLatencyHook(eventName, undefined);
    let localTimestamp = Core__Option.getOr(timestamp, Date.now().toString());
    let localTimestampFloat = Core__Option.getOr(Core__Float.fromString(localTimestamp), Date.now());
    conditionalLogPush({
      timestamp: localTimestamp,
      logType: logType,
      category: logCategory,
      source: sourceString,
      version: repoVersion,
      value: value,
      sessionId: sessionId$1.contents,
      merchantId: merchantId$1.contents,
      paymentId: getPaymentId(),
      appId: "",
      platform: window.navigator.platform,
      browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
      browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
      userAgent: window.navigator.userAgent,
      eventName: eventName,
      latency: latency$1,
      firstEvent: firstEvent,
      paymentMethod: paymentMethod,
      metadata: metadata$1.contents
    });
    checkLogSizeAndSendData();
    events.contents[eventNameStr] = localTimestampFloat;
  };
  let setLogInitiated = () => {
    let eventNameStr = LoggerUtils$OrcaPaymentPage.eventNameToStrMapper("LOG_INITIATED");
    let firstEvent = Core__Option.isNone(events.contents[eventNameStr]);
    let latency = calculateLatencyHook("LOG_INITIATED", undefined);
    conditionalLogPush({
      timestamp: Date.now().toString(),
      logType: "INFO",
      category: "USER_EVENT",
      source: sourceString,
      version: repoVersion,
      value: "log initiated",
      sessionId: sessionId$1.contents,
      merchantId: merchantId$1.contents,
      paymentId: getPaymentId(),
      appId: "",
      platform: window.navigator.platform,
      browserName: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[0], "Others"),
      browserVersion: Core__Option.getOr(Utils$OrcaPaymentPage.arrayOfNameAndVersion[1], "0"),
      userAgent: window.navigator.userAgent,
      eventName: "LOG_INITIATED",
      latency: latency,
      firstEvent: firstEvent,
      paymentMethod: "",
      metadata: metadata$1.contents
    });
    checkLogSizeAndSendData();
    events.contents[eventNameStr] = Date.now();
  };
  let handleBeforeUnload = _event => {
    sendLogs();
    let val = timeOut.contents;
    if (val !== undefined) {
      clearTimeout(Primitive_option.valFromOption(val));
      return;
    }
  };
  window.addEventListener("beforeunload", handleBeforeUnload);
  return {
    setLogInfo: setLogInfo,
    setLogError: setLogError,
    setLogApi: setLogApi,
    setLogInitiated: setLogInitiated,
    setConfirmPaymentValue: setConfirmPaymentValue,
    sendLogs: sendLogs,
    setSessionId: setSessionId,
    setClientSecret: setClientSecret,
    setSdkAuthorization: setSdkAuthorization,
    setMerchantId: setMerchantId,
    setMetadata: setMetadata,
    setSource: setSource
  };
}

export {
  logFileToObj,
  getRefFromOption,
  getSourceString,
  make,
}
/* Utils-OrcaPaymentPage Not a pure module */
